export enum RADIUS {
    MINIMAL = '2px',
    ROUNDED = '4px',
    FULL = '16px',
    CIRCLE = '50%'
}
